<template>
  <div>
    <div class="panel panel-stretch panel-primary">
      <div class="panel-heading">
        Geselecteerde Klant
      </div>
      <div class="panel-body">
        <div v-if="selectedCustomer" class="table-responsive">
          <table class="table table-striped">
            <thead>
            <tr>
              <th>Klant</th>
              <th>Adres</th>
              <th>Contactgegevens</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td class="compact">
                <customer-badge-component :customer="selectedCustomer"></customer-badge-component>
                <br/>
                <p v-if="selectedCustomer.birthday">{{ selectedCustomer.birthday }}</p>
              </td>
              <td>
                <div v-if="hasAddress">
                  <p v-if="getProperty !== null">
                    {{ getProperty.street }} {{ getProperty.number }}{{ getProperty.number_letter }} {{ getProperty.number_addition }}<br>
                    {{ getProperty.postal_code }} {{ getProperty.city }}
                  </p>
                  <p v-else>
                    -
                  </p>
                </div>
              </td>
              <td>
                <p v-if="selectedCustomer.email_address"><i class="mdi mdi-at"></i> {{ selectedCustomer.email_address }}
                </p>
                <p v-if="selectedCustomer.phone">{{ selectedCustomer.phone }}</p>
                <p v-if="selectedCustomer.mobile">{{ selectedCustomer.mobile }}</p>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div v-else-if="newCustomerData && newCustomerData.type == 1">
          <table class="table table-striped">
            <thead>
            <tr>
              <th>Naam</th>
              <th>Type</th>
              <th v-if="newCustomerData.sex">Geslacht</th>
              <th>Geboortedatum</th>
              <th>Contactgegevens</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>
                {{ newCustomerNameDisplay }}
              </td>
              <td>{{ newCustomerTypeDisplay }}</td>
              <td v-if="newCustomerData.sex">{{ newCustomerSexDisplay }}</td>
              <td>{{ newCustomerData.dateOfBirth }}</td>
              <td>
                <p v-if="newCustomerData.emailAddress">
                  <i class="mdi mdi-at"></i> {{ newCustomerData.emailAddress }}
                </p>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div v-else-if="newCustomerData && newCustomerData.type == 9">
          <table class="table table-striped">
            <thead>
            <tr>
              <th>Naam</th>
              <th>Type</th>
              <th>Oprichtingsdatum</th>
              <th>Contactgegevens</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>
                {{ newCustomerData.companyName }}
              </td>
              <td>{{ newCustomerTypeDisplay }}</td>
              <td>{{ newCustomerData.startDate }}</td>
              <td>
                <p v-if="newCustomerData.emailAddress">
                  <i class="mdi mdi-at"></i> {{ newCustomerData.emailAddress }}
                </p>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div v-else>
          Selecteer een klant
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import {mapGetters} from 'vuex'
import store from '../../../store';
import siviModule from '../store'
import CustomerBadgeComponent from "../../customer/components/BadgeComponent";

export default {
  name: "ShowCustomerComponent",
  data() {
    return {}
  },
  created() {
    if (!store.hasModule('sivi')) {
      store.registerModule('sivi', siviModule)
    }
  },
  computed: {
    ...mapGetters('sivi', [
      'selectedCustomer',
      'newCustomerData'
    ]),
    hasAddress() {
      return (this.selectedCustomer.current_visit_customer_property !== null
          && typeof this.selectedCustomer.current_visit_customer_property !== 'undefined'
          && this.selectedCustomer.current_visit_customer_property.data.property !== null
          && typeof this.selectedCustomer.current_visit_customer_property.data.property !== 'undefined'
      );
    },
    getProperty() {
      if (!this.hasAddress) return null;

      const property = this.selectedCustomer.current_visit_customer_property.data.property.data;

      if (property !== null && typeof property !== 'undefined' && Object.keys(property).length !== 0) {
        return {
          street: property.street,
          number: property.number,
          number_letter: property.number_letter ? property.number_letter : '',
          number_addition: property.number_addition ? property.number_addition : '',
          postal_code: property.postal_code.toUpperCase(),
          city: property.city ? property.city.charAt(0).toUpperCase() + property.city.slice(1) : ''
        };
      }

      return null;
    },

    dateOfBirth() {
      if (this.selectedCustomer) {
        // TODO fix
        return this.selectedCustomer.date_of_birth.substring(0, 10);
      }
    },
    newCustomerNameDisplay() {
      if (this.newCustomerData) {
        let displayName = ''
        if (this.newCustomerData.firstName) displayName = displayName.concat(this.newCustomerData.firstName, ' ');
        if (this.newCustomerData.suffix) displayName = displayName.concat(this.newCustomerData.suffix, ' ');
        if (this.newCustomerData.lastName) displayName = displayName.concat(this.newCustomerData.lastName, ' ');
        if (this.newCustomerData.initials) displayName = displayName.concat('(', this.newCustomerData.initials, ')');
        return displayName;
      }
      return ''
    },
    newCustomerSexDisplay() {
      if (this.newCustomerData.sex == "1") {
        return 'Man';
      } else if (this.newCustomerData.sex == "0") {
        return 'Vrouw';
      } else {
        return 'Onbekend';
      }
    },
    newCustomerTypeDisplay() {
      if (this.newCustomerData.type == "1") {
        return 'Particulier';
      } else if (this.newCustomerData.type == "9") {
        return 'Zakelijk';
      }
    },
  },
  mounted() {
  },
  methods: {},
  components: {CustomerBadgeComponent},
}
</script>

<style scoped>
table.table th, table.table td {
  padding: 1.5rem 1rem;
}
</style>